export const twitterUrl = new URL('/minmaxfm', 'https://twitter.com')
export const blueskyUrl = new URL(
  '/profile/minmaxfm.bsky.social',
  'https://bsky.app'
)
export const instagramUrl = new URL('/minmaxfm', 'https://instagram.com')
export const youTubeUrl = new URL('/@minmaxfm', 'https://youtube.com')
export const twitchUrl = new URL('/minmaxfm', 'https://twitch.tv')
export const telegramUrl = new URL('/minmaxfm', 'https://t.me')
export const tikTokUrl = new URL('/@minmaxfm', 'https://tiktok.com')
export const discogsUrl = new URL(
  '/user/minmaxfm/collection',
  'https://www.discogs.com'
)
export const goodReadsUrl = new URL('/minmaxfm', 'https://goodreads.com')
